<app-table
  [data]="data"
  [columns]="headers"
  [mainField]="'name'"
  [title]="'configuration.platforms.listTitle' | transloco"
  [rows]="limit"
  [totalRecords]="totalRecords"
  [loadError]="loadError"
  (retryLoad)="loadPlatforms()"
  [isLoading]="isLoading"
  (onPageChange)="onPageChange($event)"
  (onSort)="onSort($event)"
  [showActionButton]="!isMobile"
  [actionButtonLabel]="isMobile ? '' : ('configuration.platforms.createButton' | transloco)"
  [crudComponent]="crudPlatform"
  (actionButtonClick)="crudPlatform.show()"
  [getMenuActions]="getMenuActions.bind(this)"
  (menuActionTriggered)="menuActionTriggered($event)"
  (rowSelected)="onRowSelected($event)"
></app-table>

@if (isMobile) {
  <app-button
    class="floating-add-button"
    icon="Plus"
    (click)="crudPlatform.show()"
  ></app-button>
}

<app-platform-crud #crudPlatform (platformUpdated)="onPlatformSaved($event)"></app-platform-crud>
